import { useNavigate } from 'react-router-dom';
import { Lock, Crown, ArrowRight } from 'lucide-react';
import { useWallet } from '../../../../context/wallet/WalletContext';

const WalletLockBanner = () => {
  const navigate = useNavigate();
  const { isStarterPlan } = useWallet();

  if (!isStarterPlan) return null;

  return (
    <div className="rounded-3xl p-5 sm:p-6 bg-gradient-to-r from-amber-500/10 via-amber-500/5 to-teal-500/10 border border-amber-200/80 shadow-sm flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
      <div className="flex items-start sm:items-center gap-3.5">
        <div className="w-11 h-11 rounded-2xl bg-amber-100/90 border border-amber-200 flex items-center justify-center text-amber-700 shrink-0 shadow-2xs">
          <Lock size={20} />
        </div>
        <div>
          <h3 className="font-bold text-slate-900 text-sm sm:text-base flex items-center gap-2">
            <span>Wallet Payouts are Locked on Starter Plan</span>
            <span className="text-[10px] uppercase font-bold tracking-wider px-2 py-0.5 bg-amber-200/60 text-amber-900 rounded-md">
              Locked
            </span>
          </h3>
          <p className="text-xs text-slate-600 mt-1 max-w-2xl leading-relaxed">
            Your traveller commission earnings are actively accrued and safe in your wallet. Upgrade to <b>Pro Plan</b> or <b>Growth Plan</b> to unlock instant redemption via UPI and Bank Transfers.
          </p>
        </div>
      </div>
      <button
        onClick={() => navigate('/subscription')}
        className="bg-[#067978] hover:bg-[#056362] text-white text-xs font-bold px-5 py-2.5 rounded-xl flex items-center gap-2 shrink-0 shadow-md shadow-[#067978]/25 transition-all active:scale-95 cursor-pointer"
      >
        <Crown size={14} />
        <span>Upgrade to Unlock Payouts</span>
        <ArrowRight size={13} />
      </button>
    </div>
  );
};

export default WalletLockBanner;
